import { ref } from 'vue';
import store from '@/store';
import { config } from '@/config.js';
import { useRoute, useRouter } from '@/composables/common/router/useRouter';
import { useToast } from '@/composables/common/useToast';

export function useCrearCategoria() {
    const route = useRoute();
    const router = useRouter();
    const toast = useToast();

    const loading = ref(false);
    const saveError = ref(null);

    async function save(formData) {
        loading.value = true;
        saveError.value = null;

        const lista_id = route.params.lista_id;

        const params = {
            ...formData,
            indumentariasSelect: formData.indumentarias_ids
                ? formData.indumentarias_ids.map(id => ({ id }))
                : [],
            frecuencias: formData.frecuencia_ids
                ? formData.frecuencia_ids.map(id => ({ id }))
                : [],
            filters: {},
            lista_abonados_id: lista_id,
            lista_id
        };
        delete params.indumentarias_ids;
        delete params.frecuencia_ids;

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.categorias.crear'),
                params
            );
            toast.success(res.data.message || 'Categoría creada correctamente');
            router.push({
                name: 'back.bases.categorias.index',
                params: { lista_id }
            });
        } catch (error) {
            const message = error?.response?.data?.message || 'Error al crear la categoría';
            saveError.value = message;
            toast.error(message);
        } finally {
            loading.value = false;
        }
    }

    return {
        loading,
        save,
        saveError
    };
}
